import script from "./ArtWorksModalSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtWorksModalSwiper.vue?vue&type=script&setup=true&lang=js"

import "./ArtWorksModalSwiper.vue?vue&type=style&index=0&id=82c53dba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82c53dba"]])

export default __exports__